import { Serializable } from '@/models/core/serializable';
import { CompetencyByType } from '@/models/competency/competency-by-type';
import { GEnum } from '@/constants/enum.defination';

export class StudentCompetencySummary implements Serializable<StudentCompetencySummary> {
  giftScoreSummary: SummaryData[] = [];
  selfEvalScoreSummary: SummaryData[] = [];
  competencyByTypes: CompetencyByType[] = [];

  deserialize(input: any): StudentCompetencySummary {
    if (input.giftScoreSummary) {
      this.giftScoreSummary = input.giftScoreSummary.map((summaryData: SummaryData) => new SummaryData().deserialize(summaryData));
    }
    if (input.selfEvalScoreSummary) {
      this.selfEvalScoreSummary = input.selfEvalScoreSummary.map((summaryData: SummaryData) => new SummaryData().deserialize(summaryData));
    }
    if (input.competencyByTypes) {
      this.competencyByTypes = input.competencyByTypes.map((competencyByType: any) => new CompetencyByType().deserialize(competencyByType));
    }
    return this;
  }

  selfScoresByType(competencyType: GEnum.CompetencyType): number[] {
    const index: number = this.selfEvalScoreSummary.findIndex((summaryData: SummaryData) => summaryData.type === competencyType);
    if (index < 0) {
      return [];
    } else {
      return this.selfEvalScoreSummary[index].value;
    }
  }

  giftScoresByType(competencyType: GEnum.CompetencyType): number[] {
    const index: number = this.giftScoreSummary.findIndex((summaryData: SummaryData) => summaryData.type === competencyType);
    if (index < 0) {
      return [];
    } else {
      return this.giftScoreSummary[index].value;
    }
  }

  competencyNamesByType(competencyType: GEnum.CompetencyType): string[] {
    const index: number = this.competencyByTypes.findIndex((competencyByType: CompetencyByType) => competencyByType.competencyType === competencyType);
    if (index < 0) {
      return [];
    } else {
      return this.competencyByTypes[index].names;
    }
  }
}

export class SummaryData implements Serializable<SummaryData> {
  type: number;
  value: number[];

  deserialize(input: any): SummaryData {
    this.type = input.type;
    this.value = input.value;
    return this;
  }
}
